<template>
  <div class="changestate">
    <ul class="changestateul">
      <li
        v-for="(tab, index) in tabs"
        @click="toggle(index, tab.view)"
        :class="{ active: active == index }"
        :key="index"
      >
        {{ tab.type }}
      </li>
    </ul>
    <div class="clearfix"></div>
    <!--:is实现多个组件实现同一个挂载点-->
    <component
      :is="currentView"
      :arrs="arrs"
      @changeView="changeView"
      @getList="getList"
      :currentId="currentId"
      @listEvent="listEvent"
    ></component>
  </div>
</template>

<script>
import StartSchool from "./StartSchool";
import StartModelForm from "./StartModelForm";
export default {
  name: "StartState",
  components: {
    StartSchool,
    StartModelForm,
  },
  data: function () {
    return {
      active: 0,
      currentView: "StartSchool",
      tabs: [
        {
        type: "线下上传",
        view: "StartSchool",
        },
        {
          type: "线下录入",
          view: "StartModelForm",
        },
      ],
      arrs: [],
      currentId: null,
    };
  },
  created() {
    this.getApplyData();
  },
  methods: {
    toggle(i, v) {
      this.active = i;
      this.currentView = v;
    },
    getApplyData() {
      this.axios.get(`/biz/archive/apply/list`).then((res) => {
        this.arrs = res.result;
        this.currentId = this.arrs[0] ? this.arrs[0].id : null;
      });
    },
    changeView(id) {
      console.log(id);
      this.currentView = "ViewTrack";
      this.active = 2;
      this.currentId = id;
    },
    getList() {
      this.getApplyData();
    },
    listEvent(val){//子传父传递checkFlag为true，就是审核通过就不显示填写入学登记表
      if(val){
        this.tabs.splice(0,1)
      }
      console.log(this.tabs)
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.changestate {
  background: $bgcontent;
  min-height: 500px;
  padding: 28px;

  .changestateul li {
    float: left;
    margin-right: 30px;
    width: 108px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    color: #999999;
    cursor: pointer;
    text-align: center;
    border-radius: 3px;

    &.active {
      background: $bgColor;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/StartState.vue